import { BrowserRouter } from "react-router-dom"
// import styles from "./App.module.css"
import { Router } from "./router";
import { GlobalApiErrorNotifications } from "./components/UI/GlobalApiErrorNotifications";

function App() {
  return (
      <BrowserRouter>
        <GlobalApiErrorNotifications />
        <Router />
      </BrowserRouter>
  );
}

export default App;
